import {
    head,
    filter,
    propEq,
    pipe,
    sortWith,
    descend,
    prop,
} from "ramda"

export const getModelPrices1 = async (rental, models, tourPrices, vehicle_model_1) => {
  /**
   * se encarga de buscar el precio de una moto asociado a un tour
   * 
   * attrs:
   *  rental => obj => datos del rental
   *  models => arr => lista de motos disponibles
   *  tourPrice => arr => lista de precios asociados al tour
   *  vehicle_model_1 => obj => datos del vehiculo seleccionado
   * 
   * returns:
   *  price => int => precio de la moto seleccionada
   */
  if(rental.vehicle.length > 0){
      const selectedModel = head(filter(propEq("id", vehicle_model_1), models));
  
      if (selectedModel.model_name === "Own Motorcycle") {
        return 0;
      }

      const priceDate = rental.booking && rental.booking.price_date
        ? new Date(rental.booking.price_date)
        : null;
      const selectedUpPrice = head(
        pipe(
          filter(propEq("price_item_sub_type", `tour_${selectedModel.upgrade_type}`)),
          filter(
            (item) =>
              !priceDate || !item.start_date || new Date(item.start_date) <= priceDate
          ),
          sortWith([descend(prop("start_date"))])
        )(tourPrices)
      );
      return selectedUpPrice ? selectedUpPrice.price : 0;
    }else{
      return 0
    }
  }


// WEBPACK FOOTER //
// ./src/util/getModels.js